/**
 * 用户条款
 * Created by Yata on 2017/9/21 0001.
 */

export default [{
  path: '/park/help',
  component: () => import('../components/park/help.vue'),
  meta:{title : "停车帮助"}
},
{
path: '/park/monthlyParking',
component: () => import('../components/park/monthlyParking.vue'),
meta:{title : "月保车场查询"}
},
{
  path: '/RKE/help',
  component: () => import('../components/RKE/help.vue'),
  meta: {
      title: "使用帮助"
  }
},
{
  path: '/rule/:type', // /rule/integral  积分规则    /rule/checkin   签到规则
  component: () => import('../components/rule/help.vue'),
  meta: {
      title: "签到规则"
  }
}
]
